<template>
  <div id="home">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'home',
  data(){
    return {
      
    }
  },
  created() {
    
  },
  methods: {
    
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/home/Home.vue